import { openDB } from 'idb'

const DB_NAME = 'model3d-store'
const MODEL_FILE_STORE = 'modelFiles'

const getDB = () => openDB(DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(MODEL_FILE_STORE)) {
      db.createObjectStore(MODEL_FILE_STORE, { keyPath: 'id', autoIncrement: true })
    }
  },
})

export const addModelFile = async (data, originalFilename, type) => {
  const db = await getDB()
  const tx = db.transaction(MODEL_FILE_STORE, 'readwrite')
  const id = await tx.objectStore(MODEL_FILE_STORE).add({ data, originalFilename, type })
  await tx.done
  return id
}

export const getModelFile = async (id) => {
  const db = await getDB()
  const tx = db.transaction(MODEL_FILE_STORE, 'readonly')
  const record = await tx.objectStore(MODEL_FILE_STORE).get(id)
  await tx.done
  return record
}

export const deleteModelFile = async (id) => {
  const db = await getDB()
  const tx = db.transaction(MODEL_FILE_STORE, 'readwrite')
  await tx.objectStore(MODEL_FILE_STORE).delete(id)
  await tx.done
}
